(() => {
  const parseConfig = (el) => {
    const id = el.getAttribute('data-config-id');
    const node = id ? document.getElementById(id) : null;
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (_) {
      return null;
    }
  };

  class WallletterCraft extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.config = parseConfig(this) || { sizes: [], i18n: {}, whatsapp: '905325516844' };
      this.selectedSize = this.config.sizes?.[0] || null;

      document.querySelectorAll('product-info, .product, .product-information').forEach((el) => {
        el.classList.add('product--walllettercraft');
        if (window.HarfmixCraftPdp) window.HarfmixCraftPdp.init({ quoteOnly: true });
      });

      this._renderSizes();
      this._bind();
      this._syncQuoteLink();
    }

    _renderSizes() {
      const host = this.querySelector('[data-wl-sizes]');
      if (!host) return;
      host.innerHTML = '';
      (this.config.sizes || []).forEach((size, index) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wallletter-craft__pill';
        btn.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
        btn.dataset.sizeId = size.id;
        btn.innerHTML = `${size.label}<span class="wallletter-craft__pill-meta">${size.meta || ''}</span>`;
        host.appendChild(btn);
      });
    }

    _bind() {
      this.addEventListener('click', (event) => {
        const btn = event.target.closest('.wallletter-craft__pill');
        if (!btn || !this.contains(btn)) return;
        const size = (this.config.sizes || []).find((s) => s.id === btn.dataset.sizeId);
        if (!size) return;
        this.selectedSize = size;
        this.querySelectorAll('.wallletter-craft__pill').forEach((el) => {
          el.setAttribute('aria-pressed', el === btn ? 'true' : 'false');
        });
        this._syncQuoteLink();
      });
    }

    _syncQuoteLink() {
      const link = this.querySelector('[data-wl-quote]');
      if (!link) return;
      const title = this.config.productTitle || 'Duvar Tipi Harf';
      const height = this.selectedSize?.wa || this.selectedSize?.label || '';
      const text = height
        ? `${title} — yükseklik ${height} için fiyat teklifi almak istiyorum.`
        : this.config.i18n?.waTemplate || `${title} için fiyat teklifi almak istiyorum.`;
      const phone = this.config.whatsapp || '905325516844';
      link.href = `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
    }
  }

  if (!customElements.get('wallletter-craft')) {
    customElements.define('wallletter-craft', WallletterCraft);
  }
})();
